import { useTranslations } from 'next-intl'
import { useForm } from 'react-hook-form'

import {
  PhoneVerificationButton,
  type PhoneVerificationResult,
  type TPhoneVerificationForm,
} from '@/features/verify-identity'
import { Form } from '@/shared/ui'

type Props = {
  onSuccess: (result: PhoneVerificationResult) => void
  className?: string
}

export const PhoneVerification = ({ onSuccess, className }: Props) => {
  const t = useTranslations('verification')

  const form = useForm<TPhoneVerificationForm>()

  const handleVerificationSuccess = (result: PhoneVerificationResult) => {
    onSuccess(result)
  }

  return (
    <Form.Root form={form} className={className}>
      <div className="flex flex-col gap-2">
        <PhoneVerificationButton onSuccess={handleVerificationSuccess}>
          {t('button.verify_phone')}
        </PhoneVerificationButton>
      </div>
    </Form.Root>
  )
}
